import React from 'react';
import { useSelector } from 'react-redux';

import { Sidecar } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../../../../model';

import styles from './Completed.scss';

const Completed: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournament = useSelector(widgetSelect.getTournament);
  return (
    <div className={styles.root}>
      <Sidecar.WinnerItem
        classes={{
          root: styles.winnerItem,
          details: styles.winnerDetails
        }}
        prizePoolUnit={tournament.prizePoolUnit}
        winner={tournament.winner}
        winnerAward={tournament.formattedWinnerAward}
      />
    </div>
  );
};

export default Completed;
